import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'

import { selectors as UserPreferencesSelectors } from 'data/userPreferences'

import { providesUserPreferencesMutations } from 'components/Settings/User/dataSync'

export const withFavoriteChannelControls = compose(
  providesUserPreferencesMutations,
  connect((state, { channelId }) => ({
    isFavorite: UserPreferencesSelectors.isChannelFavorite(state, channelId),
    favoriteChannelIds: UserPreferencesSelectors.getFavoriteChannelIds(state),
  })),
  withProps(
    ({ channelId, isFavorite, updateUserPreferences, favoriteChannelIds }) => ({
      onToggleFavorite() {
        updateUserPreferences({
          favoriteChannelIds: isFavorite
            ? favoriteChannelIds.filter(
                favoriteChannelId => favoriteChannelId !== channelId
              )
            : favoriteChannelIds.add(channelId),
        })
      },
      isFavorite,
    })
  )
)
